<header class="it-header-wrapper">
	<div class="it-header-slim-wrapper">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="it-header-slim-wrapper-content">
						<a class="d-lg-block navbar-brand" href="https://www.regione.emilia-romagna.it/"
							>Regione Emilia-Romagna</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="it-nav-wrapper">
		<div class="it-header-center-wrapper pt-0">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<div class="it-header-center-content-wrapper">
							<div class="it-brand-wrapper">
								<a href="https://mobilita.regione.emilia-romagna.it/">
									<img
										class="icon"
										[attr.src]="environment.contextRoot + '/assets/images/logo-rer-w.png'"
										width="82"
										height="82"
										alt="Logo Regione Emilia-Romagna - clicca per andare alla home del portale mobilità" />
									<div class="it-brand-text">
										<div class="it-brand-title">Mobilità</div>
									</div>
								</a>
							</div>
							<div class="it-right-zone">
								<div class="it-socials d-none">
									<span>Seguici su</span>
									<ul>
										<li class="list-inline-item">
											<a
												title="Facebook"
												href="https://www.facebook.com/RegioneEmiliaRomagna"
												target="_blank"
												rel="noopener noreferrer"
												><app-icon name="it-facebook" color="white"> </app-icon>
												<span class="visually-hidden">Facebook</span></a
											>
										</li>
										<li class="list-inline-item">
											<a
												title="Instagram"
												href="https://www.instagram.com/regione_emiliaromagna"
												target="_blank"
												rel="noopener noreferrer"
												><app-icon name="it-instagram" color="white"> </app-icon>
												<span class="visually-hidden">Instagram</span></a
											>
										</li>
										<li class="list-inline-item">
											<a
												title="Twitter"
												href="https://twitter.com/regioneer"
												target="_blank"
												rel="noopener noreferrer"
												><app-icon name="it-twitter" color="white"> </app-icon>
												<span class="visually-hidden">Twitter</span></a
											>
										</li>
										<li class="list-inline-item">
											<a
												title="Youtube"
												href="https://www.youtube.com/channel/UCyY8KeHCpTid2SzoU11ozyw"
												target="_blank"
												rel="noopener noreferrer"
												><app-icon name="it-youtube" color="white"> </app-icon>
												<span class="visually-hidden">Youtube</span></a
											>
										</li>
										<li class="list-inline-item">
											<a
												title="Linkedin"
												href="https://it.linkedin.com/company/regione-emilia-romagna"
												target="_blank"
												rel="noopener noreferrer"
												><app-icon name="it-linkedin" color="white"> </app-icon>
												<span class="visually-hidden">Linkedin</span></a
											>
										</li>
									</ul>
								</div>
								<div class="it-search-wrapper d-none">
									<span class="d-none d-md-block">Cerca</span>
									<a
										class="search-link rounded-icon"
										aria-label="Cerca nel sito"
										href="https://mobilita.regione.emilia-romagna.it/@@search?">
										<svg class="icon">
											<use
												[attr.href]="
													environment.contextRoot + '/assets/svg/sprites.svg#it-search'
												"></use>
										</svg>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="it-header-navbar-wrapper">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<nav class="navbar navbar-expand-lg has-megamenu" aria-label="Navigazione principale">
							<button
								class="custom-navbar-toggler"
								type="button"
								aria-controls="navC1"
								aria-expanded="false"
								aria-label="Mostra/Nascondi la navigazione"
								data-bs-toggle="navbarcollapsible"
								data-bs-target="#navC1">
								<app-icon name="it-burger" color="white"></app-icon>
							</button>
							<div class="navbar-collapsable" id="navC1" style="display: none">
								<div class="overlay" style="display: none"></div>
								<div class="close-div">
									<button class="btn close-menu" type="button">
										<span class="visually-hidden">Nascondi la navigazione</span>
										<app-icon name="it-close-big" color="white"></app-icon>
									</button>
								</div>
								<div class="menu-wrapper py-0">
									<ul class="navbar-nav">
										<li class="nav-item dropdown megamenu">
											<button
												type="button"
												class="nav-link dropdown-toggle px-lg-2 px-xl-3"
												data-bs-toggle="dropdown"
												aria-expanded="false"
												id="megamenu-5"
												data-focus-mouse="false">
												<span>Aree tematiche</span
												><svg role="img" class="icon icon-xs ms-1">
													<use
														[attr.href]="
															environment.contextRoot +
															'/assets/svg/sprites.svg#it-expand'
														"></use>
												</svg>
											</button>
											<div
												class="dropdown-menu shadow-lg"
												role="region"
												aria-labelledby="megamenu-5">
												<div class="megamenu pb-5 pt-3 py-lg-0">
													<div class="row">
														<div class="col-12">
															<div class="row">
																<div class="col-12 col-lg-4">
																	<div class="link-list-wrapper">
																		<ul class="link-list">
																			<li>
																				<a
																					class="list-item dropdown-item"
																					href="https://mobilita.regione.emilia-romagna.it/aeroporti">
																					<svg
																						role="img"
																						class="icon icon-sm me-2">
																						<use
																							[attr.href]="
																								environment.contextRoot +
																								'/assets/svg/sprites.svg#it-arrow-right-triangle'
																							"></use>
																					</svg>
																					<span>Aereoporti</span>
																				</a>
																			</li>
																			<li>
																				<a
																					class="list-item dropdown-item"
																					href="https://mobilita.regione.emilia-romagna.it/autobus-e-mobilita-urbana">
																					<svg
																						role="img"
																						class="icon icon-sm me-2">
																						<use
																							[attr.href]="
																								environment.contextRoot +
																								'/assets/svg/sprites.svg#it-arrow-right-triangle'
																							"></use>
																					</svg>
																					<span
																						>Autobus e mobilità urbana</span
																					>
																				</a>
																			</li>
																			<li>
																				<a
																					class="list-item dropdown-item"
																					href="https://mobilita.regione.emilia-romagna.it/ferrovie">
																					<svg
																						role="img"
																						class="icon icon-sm me-2">
																						<use
																							[attr.href]="
																								environment.contextRoot +
																								'/assets/svg/sprites.svg#it-arrow-right-triangle'
																							"></use>
																					</svg>
																					<span>Ferrovie</span>
																				</a>
																			</li>
																			<li>
																				<a
																					class="list-item dropdown-item"
																					href="https://mobilita.regione.emilia-romagna.it/logistica-merci">
																					<svg
																						role="img"
																						class="icon icon-sm me-2">
																						<use
																							[attr.href]="
																								environment.contextRoot +
																								'/assets/svg/sprites.svg#it-arrow-right-triangle'
																							"></use>
																					</svg>
																					<span>Logistica merci</span>
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
																<div class="col-12 col-lg-4">
																	<div class="link-list-wrapper">
																		<ul class="link-list">
																			<li>
																				<a
																					class="list-item dropdown-item"
																					href="https://mobilita.regione.emilia-romagna.it/mobility-sostenibile">
																					<svg
																						role="img"
																						class="icon icon-sm me-2">
																						<use
																							[attr.href]="
																								environment.contextRoot +
																								'/assets/svg/sprites.svg#it-arrow-right-triangle'
																							"></use>
																					</svg>
																					<span
																						>Mobilità sostenibile,
																						ciclistica, elettrica</span
																					>
																				</a>
																			</li>
																			<li>
																				<a
																					class="list-item dropdown-item"
																					href="https://mobilita.regione.emilia-romagna.it/modellazione-dei-trasporti">
																					<svg
																						role="img"
																						class="icon icon-sm me-2">
																						<use
																							[attr.href]="
																								environment.contextRoot +
																								'/assets/svg/sprites.svg#it-arrow-right-triangle'
																							"></use>
																					</svg>
																					<span
																						>Modellazione dei
																						trasporti</span
																					>
																				</a>
																			</li>
																			<li>
																				<a
																					class="list-item dropdown-item"
																					href="https://mobilita.regione.emilia-romagna.it/monitoraggio-del-sistema-di-mobilita">
																					<svg
																						role="img"
																						class="icon icon-sm me-2">
																						<use
																							[attr.href]="
																								environment.contextRoot +
																								'/assets/svg/sprites.svg#it-arrow-right-triangle'
																							"></use>
																					</svg>
																					<span
																						>Monitoraggio del sistema di
																						mobilità</span
																					>
																				</a>
																			</li>
																			<li>
																				<a
																					class="list-item dropdown-item"
																					href="https://mobilita.regione.emilia-romagna.it/pianificazione-dei-trasporti">
																					<svg
																						role="img"
																						class="icon icon-sm me-2">
																						<use
																							[attr.href]="
																								environment.contextRoot +
																								'/assets/svg/sprites.svg#it-arrow-right-triangle'
																							"></use>
																					</svg>
																					<span
																						>Pianificazione dei
																						trasporti</span
																					>
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
																<div class="col-12 col-lg-4">
																	<div class="link-list-wrapper">
																		<ul class="link-list">
																			<li>
																				<a
																					class="list-item dropdown-item"
																					href="https://mobilita.regione.emilia-romagna.it/settore-idroviario">
																					<svg
																						role="img"
																						class="icon icon-sm me-2">
																						<use
																							[attr.href]="
																								environment.contextRoot +
																								'/assets/svg/sprites.svg#it-arrow-right-triangle'
																							"></use>
																					</svg>
																					<span>Settore idroviario</span>
																				</a>
																			</li>
																			<li>
																				<a
																					class="list-item dropdown-item"
																					href="https://mobilita.regione.emilia-romagna.it/strade">
																					<svg
																						role="img"
																						class="icon icon-sm me-2">
																						<use
																							[attr.href]="
																								environment.contextRoot +
																								'/assets/svg/sprites.svg#it-arrow-right-triangle'
																							"></use>
																					</svg>
																					<span>Strade</span>
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</li>
										<li class="nav-item active">
											<a
												class="nav-link"
												href="https://mobilita.regione.emilia-romagna.it/come-fare-per"
												aria-current="page"
												><span>Come fare per</span></a
											>
										</li>
										<li class="nav-item">
											<a
												class="nav-link"
												href="https://mobilita.regione.emilia-romagna.it/leggi-atti-bandi"
												><span>Leggi Atti Bandi</span></a
											>
										</li>
										<li class="nav-item">
											<a
												class="nav-link"
												href="https://mobilita.regione.emilia-romagna.it/piani-programmi-progetti"
												><span>Piani Programmi Progetti</span></a
											>
										</li>
									</ul>
								</div>
							</div>
						</nav>
					</div>
				</div>
			</div>
		</div> -->
	</div>
</header>
<div class="public-ui">
	<section id="briciole" class="container px-4 mt-4">
		<div class="">
			<div class="row">
				<div class="col">
					<nav class="breadcrumb-container" aria-label="Percorso di navigazione">
						<ol class="breadcrumb" data-element="breadcrumb">
							<li class="breadcrumb-item">
								<a href="https://mobilita.regione.emilia-romagna.it/">Home</a>
								@if (routerService.activePageName) {
									<span class="separator">/</span>
								}
							</li>
							<li class="breadcrumb-item">
								@if (routerService.activePageName) {
									<a [href]="environment.contextRoot + '/'">Portale viabilità</a>
									<!-- <span class="separator">/</span> -->
								}
							</li>
							<!-- @if (routerService.activePageName) {
								<li class="breadcrumb-item">
									<span>{{ routerService.activePageName }}</span>
								</li>
							} -->
						</ol>
					</nav>
				</div>
			</div>
		</div>
	</section>
</div>
